import BGLoading from './BGLoading';

let $vm;


const plugin = {
  install(Vue, options) {
    if (!$vm) {
      const LoadingPlugin = Vue.extend(BGLoading);

      $vm = new LoadingPlugin({
        el: document.createElement('div')
      });

      document.body.appendChild($vm.$el);
    }

    $vm.show = false;

    let loading = {
      show() {
        $vm.show = true;
      },
      hide() {
        $vm.show = false;
      }
    }

    if (!Vue.$loading) {
      Vue.$loading = loading;
    }

    Vue.mixin({
      created() {
        this.$loading = Vue.$loading;
      }
    })

  }
};

export default plugin;




// WEBPACK FOOTER //
// ./src/components/BGLoading/index.js